import BPService from '../../../api/business-profile.service'
import { sortBenefits } from './helpers.js'

const actions = {
  async getProfile(context) {
    try {
      let profileData = await BPService.getProfile()
      console.log('profile data log: ', profileData)
      if (profileData.length) {
        context.commit('updateAboutUs', profileData[0].aboutUs || '')
        context.commit('updateSlogan', profileData[0].slogan || profileData[0].slogun || '')
        context.commit('updateBanner', profileData[0].banner || '')
        context.commit('updateIsPublished', profileData[0].published || false)
        context.commit('updateTeam', profileData[0].BpTeams || [])
        context.commit('updateInside', profileData[0].BPInside || [])
        context.commit('getSocials', profileData[0].BPSocial || [])
      }
      return profileData
    } catch (e) {
      console.log(e)
      throw e.response
    }
  },

  async getBenefits(context) {
    try {
      let profileData = await BPService.getProfile()
      console.log('profileData: ', profileData)
      if (profileData.length) {
        console.log('profileData.BPBenefits: ', profileData[0].BPBenefits)

        context.commit('updateBenefits', sortBenefits(profileData[0].BPBenefits))
      }
    } catch (e) {
      throw e.response
    }
  },

  async getKPI(context) {
    try {
      let profileData = await BPService.getProfile()
      console.log('profileData: ', profileData)
      if (profileData.length) {
        if (profileData[0].BPKpi.length) {
          context.commit('updateKpi', [...profileData[0].BPKpi])
        }
        return profileData[0].BPKpi
      }
    } catch (e) {
      throw e.response
    }
  },

  async createKPI(context, data) {
    try {
      await BPService.KPICreate(data)
    } catch (e) {
      throw e.response
    }
  },

  async updateKPI(context, data) {
    try {
      await BPService.KPIUpdate(data)
    } catch (e) {
      throw e.response
    }
  },

  async createProfile(context, data) {
    try {
      await BPService.createProfile(data)
    } catch (e) {
      throw e.response
    }
  },

  async updateProfile(context, data) {
    try {
      await BPService.updateProfile(data)
    } catch (e) {
      throw e
    }
  },

  async sendEmail(context, data) {
    try {
      await BPService.sendEmail(data)
    } catch (e) {
      throw e
    }
  },

  async getAllBenefits(context, lang) {
    try {
      let benefits = await BPService.getBenefits(lang)
      context.commit('updateAllBenefits', benefits)
    } catch (e) {
      throw e.response
    }
  },

  async createBenefit(_context, data) {
    try {
      await BPService.createBenefit(data)
    } catch (e) {
      throw e.response
    }
  },

  async updateBenefit(_context, data) {
    try {
      await BPService.updateBenefit(data)
    } catch (e) {
      throw e.response
    }
  },

  async updateTeam(_context, data) {
    try {
      await BPService.updateTeam(data)
    } catch (e) {
      throw e.response
    }
  },

  async getSocials(context) {
    try {
      const data = await BPService.getProfile()
      if (data.length) {
        context.commit('getSocials', data[0].BPSocial)
      }
    } catch (e) {
      throw e.response
    }
  },

  async createSocials(_context, data) {
    try {
      await BPService.createSocials(data)
    } catch (e) {
      throw e.response
    }
  },

  async updateSocials(_context, data) {
    try {
      await BPService.updateSocials(data)
    } catch (e) {
      throw e.response
    }
  },

  async uploadInsideMedia(_context, data) {
    try {
      await BPService.uploadInsideMedia(data)
    } catch (e) {
      throw e.response
    }
  },

  async deleteInsideMedia(_context, data) {
    try {
      await BPService.deleteInsideMedia(data)
    } catch (e) {
      throw e.response
    }
  },

  async getPublicProfile(_context, data) {
    try {
      let response = await BPService.getPublicProfile(data)
      console.log('response: ', response)
      _context.commit('updatePublicProfile', response || {})
    } catch (e) {
      throw e.response
    }
  },
}

export default actions
